import {
  Archive,
  CheckSquare,
  GraduationCap,
  PaperPlaneTilt,
  Target,
} from 'phosphor-react';

const navLinks = [
  {
    href: '/alteracoes-de-email',
    icon: <GraduationCap size={32} />,
    text: 'Formação',
  },
  {
    href: '/alteracoes-de-email',
    icon: <Archive size={32} />,
    text: 'Experiência',
  },
  {
    href: '/alteracoes-de-email',
    icon: <PaperPlaneTilt size={32} />,
    text: 'Contato',
  },
  {
    href: '/alteracoes-de-email',
    icon: <CheckSquare size={32} />,
    text: 'Habilidades',
  },
];

export default navLinks;
